/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AddEditCSRComponent } from './CSRs/addEditCSR/addEditCSR.component';
import { AddEditCertComponent } from './Certs/addEditCert/addEditCert.component';
import { AuthGuard } from '../../../../../core/guards';
import { CertsApiService } from '../../../shared/http';
import { CountryDropdownComponent } from '../../../shared/components';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';
import { SSLCertificateComponent } from './ssl-certificate.component';
import { SSLCertificateResolver } from '../../../shared/resolvers';
import { UploadPemPfxComponent } from './pemPfx/uploadPemPfx/uploadPemPfx.component';

/**
 *
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule
    ],
    declarations: [
        AddEditCSRComponent,
        AddEditCertComponent,
        CountryDropdownComponent,
        SSLCertificateComponent,
        UploadPemPfxComponent,
    ],
    providers: [
        AuthGuard,
        CertsApiService,
        SSLCertificateResolver
    ]
})

export class SSLCertificateModule {
}
